/* eslint react-hooks/exhaustive-deps: "warn" */

import { useInt } from 'hooks/useInt';

import { TitleBlock } from 'ui/atoms/TitleBlock/TitleBlock';
import { Section } from 'ui/molecules/Section/Section';

import styles from './DataDictionaryHero.module.scss';

import { TrustCard } from './DataDictionaryHero.types';

type Translate = (key: string) => string;

const getTrustCards = (t: Translate): TrustCard[] => [
  { title: t('Government-Sourced'), text: t('Data collected directly from 400+ official registries') },
  { title: t('Full Source Attribution'), text: t('Every data point traced back to its original source') },
  { title: t('Original Filings'), text: t('Taken from the documents companies file with the registry') },
  { title: t('Timestamped Records'), text: t('Every record carries the date it was last updated at source') },
];

export const DataDictionaryHero = () => {
  const { t } = useInt();

  const trustCards = getTrustCards(t);

  return (
    <Section className={styles.root}>
      <div className={styles.glow} aria-hidden="true" />

      <div className={styles.head}>
        <TitleBlock
          size="page"
          title={t('Every field. Every source. Fully documented.')}
          description={t(
            'Complete schema documentation for 600M+ company profiles sourced directly from 400+ government registries across 200+ countries.',
          )}
        />
      </div>

      <div className={styles.bar}>
        {trustCards.map((card) => (
          <div className={styles.item} key={card.title}>
            <span className={styles.itemIcon}>
              <svg
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M20 6 9 17l-5-5" />
              </svg>
            </span>
            <span className={styles.itemBody}>
              <span className={styles.itemTitle}>{card.title}</span>
              <span className={styles.itemText}>{card.text}</span>
            </span>
          </div>
        ))}
      </div>
    </Section>
  );
};
